export const TRUCK_CREATION_FIELDS = ["avg_speed_kmh", "loading_rate_tons_per_hour", "unloading_rate_tons_per_hour"];

export function truckCreationDefaults(truckType, trucks = []) {
  const type = String(truckType || "citerne").trim().toLowerCase();
  const sameType = trucks.filter(truck => String(truck.truck_type || "citerne").trim().toLowerCase() === type);
  return Object.fromEntries(TRUCK_CREATION_FIELDS.map(field => {
    const counts = new Map();
    for (const truck of sameType) {
      const value = Number(truck[field]);
      if (Number.isFinite(value) && value > 0) counts.set(value, (counts.get(value) || 0) + 1);
    }
    const ranked = [...counts].sort((left, right) => right[1] - left[1]);
    return [field, ranked.length && (ranked.length === 1 || ranked[0][1] > ranked[1][1]) ? ranked[0][0] : ""];
  }));
}

export function applyNewTruckDraftChange(draft, field, value, trucks = []) {
  const nextDraft = { ...draft, [field]: value };
  const automaticFields = new Set(draft.automatic_creation_fields || TRUCK_CREATION_FIELDS);
  if (TRUCK_CREATION_FIELDS.includes(field)) {
    if (value == null || String(value).trim() === "") automaticFields.add(field);
    else automaticFields.delete(field);
  }
  nextDraft.automatic_creation_fields = [...automaticFields];
  if (field === "truck_type") {
    for (const [key, defaultValue] of Object.entries(truckCreationDefaults(value, trucks))) {
      if (automaticFields.has(key)) nextDraft[key] = defaultValue;
    }
  }
  return nextDraft;
}
